import React from 'react';
import { ModusWcButton } from '@trimble-oss/moduswebcomponents-react';
import './Button.scss';

type ModusButtonProps = React.ComponentProps<typeof ModusWcButton>;

export type ButtonColor = NonNullable<ModusButtonProps['color']>;
export type ButtonSize = 'xs' | 'sm' | 'md' | 'lg';
export type ButtonShape = 'rectangle' | 'circle' | 'square';
export type ButtonVariant = 'filled' | 'outlined' | 'borderless';
export type ButtonType = 'button' | 'submit' | 'reset';

export interface ButtonProps extends ModusButtonProps {
  size?: ButtonSize;
  shape?: ButtonShape;
  variant?: ButtonVariant;
  fullWidth?: boolean;
  disabled?: boolean;
  type?: ButtonType;
}

export const Button: React.FC<ButtonProps> = (props) => {
  return (
    <ModusWcButton
      key={
        // workaround for https://github.com/trimble-oss/modus-wc-2.0/issues/1450
        typeof props.children === 'string' ? props.children : undefined
      }
      {...props}
    />
  );
};
